import { render, staticRenderFns } from "./OthpayablesList.vue?vue&type=template&id=3a97104b"
import script from "./OthpayablesList.vue?vue&type=script&lang=js"
export * from "./OthpayablesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports